const timeout = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

class WidgetHistory extends HTMLElement {
  constructor(){
    super();

    const previousUrl = document.referrer;

    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }

    this.addEventListener('click', (e) => {
      if (previousUrl === '') {
        location.href = theme.routes.allProductsCollection; // Go back to all products collection page
        return;
      }

      const url = new URL(previousUrl);
      const { pathname } = url;

      if (pathname === '/' && history.length >= 3)
        history.go(-2); // Go back twice
      else
        history.back(); // Go back once
    });
  }
}

customElements.define('widget-history', WidgetHistory);


class WidgetQuickAdd extends HTMLElement {
  constructor(){
    super();

    this.variantsEl = this.querySelector('.variant-wrapper');
    this.variants = this.querySelectorAll('.variant-wrapper [data-variant-input]');
    this.button = this.querySelector('button[name="quick-add-button"]');

    this.button.addEventListener('click', () => {
      this.variantsEl.classList.toggle('show-variants');
    });

    this.variants.forEach((el) => {
      el.addEventListener('change', (e) => this.addToCart(e));
    });
  }

  async addToCart(evt) {
    const value = +evt.target.value;

    if (!value) {
      return;
    }

    this.variantsEl.classList.add('no-event');
    this.variantsEl.classList.remove('show-variants');
    this.button.classList.add('btn--loading');

    try {
      const res = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: JSON.stringify({
          items: [{
            id: value,
            quantity: 1
          }]
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const data = await res.json();

      this.button.classList.remove('btn--loading');
      if (res.ok && res.status === 200) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data,
            addToCartBtn: this.button
          }
        }));

        this.button.classList.add('is-added');
        this.button.innerText = this.button.dataset.successText ?? 'Added to bag';
        await timeout(2000);
        this.button.classList.remove('is-added');
        this.button.innerText = this.button.dataset.defaultText ?? 'Quick add';

      } else {
        this.button.classList.add('has-errors');
        this.button.innerText = 'Not added';
        await timeout(2000);
        this.button.classList.remove('has-errors');
        this.button.innerText = this.button.dataset.defaultText ?? 'Quick add';
      }

    } catch (error) {
      console.log(error.message);
      this.button.classList.remove('btn--loading');

      this.button.classList.add('has-errors');
      this.button.innerText = 'Not added';
      await timeout(2000);
      this.button.classList.remove('has-errors');
      this.button.innerText = this.button.dataset.defaultText ?? 'Quick add';
    }

    evt.target.checked = false;
    this.variantsEl.classList.remove('no-event');
  }
}

customElements.define('widget-quick-add-form', WidgetQuickAdd);

window.widgetQuickAddForm = (el) => {
  const variantsEl = el.querySelector('.variant-wrapper');
  const variants = el.querySelectorAll('.variant-wrapper [data-variant-input]');
  const button = el.querySelector('button[name="quick-add-button"]');

  function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async function addToCart(evt) {
    const value = +evt.target.value;

    if (!value) {
      return;
    }

    variantsEl.classList.add('no-event');
    variantsEl.classList.remove('show-variants');
    button.classList.add('btn--loading');

    try {
      const res = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: JSON.stringify({
          items: [{
            id: value,
            quantity: 1
          }]
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const data = await res.json();

      button.classList.remove('btn--loading');
      if (res.ok && res.status === 200) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data,
            addToCartBtn: button
          }
        }));

        button.classList.add('is-added');
        button.innerText = button.dataset.successText ?? 'Added to bag';
        await timeout(2000);
        button.classList.remove('is-added');
        button.innerText = button.dataset.defaultText ?? 'Quick add';

      } else {
        button.classList.add('has-errors');
        button.innerText = 'Not added';
        await timeout(2000);
        button.classList.remove('has-errors');
        button.innerText = button.dataset.defaultText ?? 'Quick add';
      }

    } catch (error) {
      console.log(error.message);
      button.classList.remove('btn--loading');

      button.classList.add('has-errors');
      button.innerText = 'Not added';
      await timeout(2000);
      button.classList.remove('has-errors');
      button.innerText = button.dataset.defaultText ?? 'Quick add';
    }

    evt.target.checked = false;
    variantsEl.classList.remove('no-event');
  }

  button.addEventListener('click', () => {
    if (!variantsEl.classList.contains('animating')) {
      variantsEl.classList.add('animating');
      variantsEl.classList.toggle('show-variants');
      setTimeout(() => {
        variantsEl.classList.remove('animating');
      }, 500)
    }
  });

  variants.forEach((el) => {
    el.addEventListener('change', (e) => addToCart(e));
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const addToCartElems = document.querySelectorAll('.js-quick-add-form');
  addToCartElems.forEach(el => window.widgetQuickAddForm(el));
});

document.addEventListener('recommendations:loaded', (evt) => {
  const {detail: { section }} = evt;
  if (!section) return;

  const addToCartElems = section.querySelectorAll('.js-quick-add-form');
  addToCartElems.forEach(el => window.widgetQuickAddForm(el));
});

window.addEventListener('searchspring.domReady', function () {
  const addToCartElems = document.querySelectorAll('.js-quick-add-form');
  addToCartElems.forEach(el => window.widgetQuickAddForm(el));
}, false);